module.exports = __webpack_public_path__ + "static/media/grid-item-c4.ed901cea.png";